module.exports = {"component":"illustration","status":"prod","display-name":"Illustrations","SLDS-component-path":"/components/illustration","url-slug":"illustrations"}


//////////////////
// WEBPACK FOOTER
// ./components/illustration/docs.json
// module id = 256
// module chunks = 0